import {SceneCreatorSceneLayout_sceneDefault} from "../layout/SceneCreatorSceneLayout";
import {StoryModel} from "./StoryModel";

export const SceneCreatorStory: StoryModel<SceneCreatorSceneId, SceneCreatorSlotId> = {
    storyId: "SceneCreator",
    scenes: [
        {
            sceneId: "default",
            options: [],
            layout: SceneCreatorSceneLayout_sceneDefault,
        },
    ],
};

export type SceneCreatorSceneId = "default";
export type SceneCreatorSlotId =
    "character"
    | "outfit"
    | "characterOther"
    | "outfitOther"
    | "handItem"
    | "decorationLeft"
    | "decorationRight";
